// extracted by mini-css-extract-plugin
export default {"ratingButton":"RatingRadio_ratingButton__Fk2Ka","ratingRadio":"RatingRadio_ratingRadio__l-9RO"};